exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Terms-module__container--25LXR{\r\n    height: 48px;\r\n    background-color: #ffffff;\r\n    align-items: center;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    border-bottom: 1px solid #dddddd;\r\n    margin-left: 16px;\r\n}\r\n\r\n.Terms-module__icon--3FZD2 {\r\n    width: 32px;\r\n    height: 32px;\r\n    top: 12px;\r\n    margin-right: 7px;\r\n}\r\n\r\n.Terms-module__title--9UEIn {\r\n    font-family: Noto Sans KR;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.57;\r\n    letter-spacing: normal;\r\n    color: #555555;\r\n}", ""]);

// exports
exports.locals = {
	"container": "Terms-module__container--25LXR",
	"icon": "Terms-module__icon--3FZD2",
	"title": "Terms-module__title--9UEIn"
};